// Cloudflare Worker, der den Anthropic-Aufruf server-seitig übernimmt – der API-Key
// liegt dort in den Worker-Secrets, nicht mehr im Client. Wird sowohl für die
// Grundriss-Erkennung (floorplanExtraction.ts) als auch für Ausstattungs-Vorschläge
// (equipmentSuggestion.ts) genutzt.
const CLAUDE_WORKER_URL = "https://still-queen-98f2.sebastian-weller.workers.dev/"; // no itx

// Ruft den Worker auf und liefert den reinen Text-Inhalt der Claude-Antwort zurück.
// Wirft bei Netzwerk-/Server-Fehlern, damit Aufrufer entscheiden können, ob sie den
// Fehler dem Nutzer zeigen oder (wie equipmentSuggestion.ts) still auf eine lokale
// Heuristik zurückfallen.
export async function callClaudeWorker(message: unknown, maxTokens: number): Promise<string> {
  let response: Response;
  try {
    response = await fetch(CLAUDE_WORKER_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        max_tokens: maxTokens,
        message,
      }),
    });
  } catch {
    throw new Error("Netzwerk-/CORS-Fehler beim Aufruf des Analyse-Servers. Bitte Internetverbindung prüfen.");
  }
  const data = await response.json();
  if (!response.ok || data.error) {
    throw new Error(data?.details?.error?.message || data?.error || `HTTP ${response.status}`);
  }
  return data.content || "";
}
